/**
 * Get a promise that will be resolved in "timeout" ms
 * @param timeout timeout in milliseconds.
 */
export function promiseTimeout(timeout: number) {
  return new Promise((resolve) => setTimeout(resolve, timeout));
}
